import { createAiHttp } from "./aiHttp";

const aiHttp = createAiHttp();

class PmauService {
  GetStages() {
    return aiHttp({
      url: "/stages",
      method: "GET"
    });
  }

  UploadContentImage(contaId, file) {
    var formData = new FormData();
    formData.append("file", file);
    return aiHttp({
      url: "/content-images/" + contaId,
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  GenerateStage(contaId, stageCode, request) {
    return aiHttp({
      url: "/generate",
      data: Object.assign({}, request || {}, { conta_id: contaId, stage_code: stageCode }),
      method: "POST"
    });
  }

  GetContent(contaId, stageCode) {
    return aiHttp({
      url: "/content/" + contaId + "/" + stageCode,
      method: "GET"
    });
  }

  SaveContent(contaId, stageCode, content, selectedOptions) {
    var data = { content: content };
    if (selectedOptions !== undefined) data.selected_options = selectedOptions;
    return aiHttp({
      url: "/content/" + contaId + "/" + stageCode,
      data: data,
      method: "PUT"
    });
  }

  GetLawDraftDefault(contaId) {
    return aiHttp({
      url: "/law-draft/" + contaId + "/default",
      method: "GET"
    });
  }

  ExportChapter(contaId, chapterCode) {
    return aiHttp({
      url: "/export/" + contaId + "/" + chapterCode,
      method: "GET",
      responseType: "blob"
    });
  }

  GetExportStatus(contaId) {
    return aiHttp({
      url: "/export/" + contaId + "/status",
      method: "GET"
    });
  }

  ExportFull(contaId, format = "docx") {
    return aiHttp({
      url: "/export/" + contaId + "/full",
      params: { format: format },
      method: "GET",
      responseType: "blob"
    });
  }

  // ── Geração assíncrona/versionada do PMAU completo (.docx + .pdf) ───────

  GeneratePmauDocument(contaId) {
    return aiHttp({
      url: "/pmau-document/" + contaId + "/generate",
      method: "POST"
    });
  }

  GetPmauDocumentGenerations(contaId) {
    return aiHttp({
      url: "/pmau-document/" + contaId,
      method: "GET"
    });
  }

  // disposition "inline" (só .pdf) devolve URL para exibir no navegador (visualizador).
  GetPmauDocumentDownloadUrl(contaId, generationId, format, disposition) {
    return aiHttp({
      url: "/pmau-document/" + contaId + "/" + generationId + "/download",
      params: { format: format, disposition: disposition || "attachment" },
      method: "GET"
    });
  }

  // PMAU completo em HTML com o conteúdo atual (pré-visualização, sem gerar versão).
  // Quadros dos eixos do Plano de Ação como entram no capítulo 13 (13.N + tabela)
  GetStrategicAxesTables(contaId) {
    return aiHttp({ url: "/strategic-axes-tables/" + contaId, method: "GET" });
  }

  GetPmauDocumentPreview(contaId) {
    return aiHttp({
      url: "/pmau-document/" + contaId + "/preview",
      method: "GET",
      responseType: "text"
    });
  }

  DeletePmauDocumentGeneration(contaId, generationId) {
    return aiHttp({
      url: "/pmau-document/" + contaId + "/" + generationId,
      method: "DELETE"
    });
  }

  UploadPmauDocument(contaId, file) {
    var formData = new FormData();
    formData.append("file", file);
    return aiHttp({
      url: "/pmau-document/" + contaId + "/upload",
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  SetPrimaryPmauDocument(contaId, generationId) {
    return aiHttp({
      url: "/pmau-document/" + contaId + "/" + generationId + "/primary",
      method: "PUT"
    });
  }

  UnsetPrimaryPmauDocument(contaId, generationId) {
    return aiHttp({
      url: "/pmau-document/" + contaId + "/" + generationId + "/primary",
      method: "DELETE"
    });
  }

  // ── Dados GAAU para gráficos renderizados no cliente (Highcharts) ───────

  GetDendrometricStats(contaId) {
    return aiHttp({
      url: "/gaau/dendrometric/" + contaId,
      method: "GET"
    });
  }

  GetSpeciesStats(contaId) {
    return aiHttp({
      url: "/gaau/species/" + contaId,
      method: "GET"
    });
  }

  GetOriginStats(contaId) {
    return aiHttp({
      url: "/gaau/origin/" + contaId,
      method: "GET"
    });
  }

  GetGaauIndexStats(contaId) {
    return aiHttp({
      url: "/gaau/gaau-index/" + contaId,
      method: "GET"
    });
  }

  // ── Admin — CRUD de Variáveis PMAU ──────────────────────────────────────

  ListVariables(includeInactive = false) {
    return aiHttp({
      url: "/admin/pmau-variables",
      method: "GET",
      params: includeInactive ? { include_inactive: true } : {}
    });
  }

  CreateVariable(data) {
    return aiHttp({
      url: "/admin/pmau-variables",
      data,
      method: "POST"
    });
  }

  UpdateVariable(id, data) {
    return aiHttp({
      url: "/admin/pmau-variables/" + id,
      data,
      method: "PUT"
    });
  }

  DeleteVariable(id) {
    return aiHttp({
      url: "/admin/pmau-variables/" + id,
      method: "DELETE"
    });
  }

  // ── Por conta — Valores de variáveis ────────────────────────────────────

  GetVariableValues(contaId) {
    return aiHttp({
      url: "/pmau-variables/" + contaId,
      method: "GET"
    });
  }

  SaveVariableValues(contaId, values) {
    return aiHttp({
      url: "/pmau-variables/" + contaId,
      data: values,
      method: "PUT"
    });
  }

  UploadVariableImage(contaId, variableId, file) {
    var formData = new FormData();
    formData.append("file", file);
    return aiHttp({
      url: "/pmau-variables/" + contaId + "/" + variableId + "/image",
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  // ── Formatação do documento (por conta) ─────────────────────────────────

  GetDocumentSettingsOptions() {
    return aiHttp({
      url: "/pmau-document-settings/options",
      method: "GET"
    });
  }

  GetDocumentSettings(contaId) {
    return aiHttp({
      url: "/pmau-document-settings/" + contaId,
      method: "GET"
    });
  }

  SaveDocumentSettings(contaId, data) {
    return aiHttp({
      url: "/pmau-document-settings/" + contaId,
      data: data,
      method: "PUT"
    });
  }

  // ── Capa do PMAU (por conta) ───────────────────────────────────────────

  GetCover(contaId) {
    return aiHttp({
      url: "/pmau-cover/" + contaId,
      method: "GET"
    });
  }

  SaveCover(contaId, data) {
    return aiHttp({
      url: "/pmau-cover/" + contaId,
      data: data,
      method: "PUT"
    });
  }

  GenerateCover(contaId) {
    return aiHttp({
      url: "/pmau-cover/" + contaId + "/generate",
      method: "POST",
      timeout: 180000
    });
  }

  ExportCover(contaId) {
    return aiHttp({
      url: "/pmau-cover/" + contaId + "/export",
      method: "GET",
      responseType: "blob"
    });
  }

  // ── Admin — Habilitação do PMAU por conta ────────────────────────────────

  ListAdminContas() {
    return aiHttp({
      url: "/pmau-access/admin/contas",
      method: "GET"
    });
  }

  SetPmauAccess(contaId, habilitado) {
    return aiHttp({
      url: "/pmau-access/" + contaId,
      data: { habilitado },
      method: "PUT"
    });
  }

  // ── Admin — Permissões por usuário × módulo do PMAU ──────────────────────

  // Opções dos filtros: contas vinculadas ao admin, usuários delas e módulos.
  GetPmauPermissionOptions() {
    return aiHttp({
      url: "/pmau-permissions/admin/options",
      method: "GET"
    });
  }

  // params: { conta_id?, usuario_id?, module?, active? }
  SearchPmauPermissions(params) {
    return aiHttp({
      url: "/pmau-permissions/admin/search",
      params: params,
      method: "GET"
    });
  }

  SetPmauUserPermissions(contaId, usuarioId, modules) {
    return aiHttp({
      url: "/pmau-permissions/admin/" + contaId + "/" + usuarioId,
      data: { modules },
      method: "PUT"
    });
  }

  // ── Admin — CRUD de Prompts ──────────────────────────────────────────────

  ListPrompts(stageCode = null) {
    const params = stageCode ? { stage_code: stageCode } : {};
    return aiHttp({
      url: "/admin/prompts",
      method: "GET",
      params
    });
  }

  GetPrompt(stageCode, promptType) {
    return aiHttp({
      url: "/admin/prompts/" + stageCode + "/" + promptType,
      method: "GET"
    });
  }

  UpdatePrompt(stageCode, promptType, data) {
    return aiHttp({
      url: "/admin/prompts/" + stageCode + "/" + promptType,
      data,
      method: "PUT"
    });
  }

  CreatePrompt(data) {
    return aiHttp({
      url: "/admin/prompts",
      data,
      method: "POST"
    });
  }

  DeletePrompt(stageCode, promptType) {
    return aiHttp({
      url: "/admin/prompts/" + stageCode + "/" + promptType,
      method: "DELETE"
    });
  }

  // ── Prompts dos capítulos no escopo da conta (técnico) ───────────────────

  ListContaPrompts(contaId) {
    return aiHttp({ url: "/pmau-prompts/" + contaId, method: "GET" });
  }

  SaveContaPrompt(contaId, stageCode, promptType, content) {
    return aiHttp({
      url: "/pmau-prompts/" + contaId + "/" + stageCode + "/" + promptType,
      data: { content },
      method: "PUT"
    });
  }

  // Remove a versão da conta — o capítulo volta a usar o prompt padrão.
  ResetContaPrompt(contaId, stageCode, promptType) {
    return aiHttp({
      url: "/pmau-prompts/" + contaId + "/" + stageCode + "/" + promptType,
      method: "DELETE"
    });
  }
}

export default new PmauService();
